/**
 * Menu Data Model for IdlyKadai
 * 
 * Dish Object Structure:
 * {
 *   id: number,
 *   name: string,
 *   description: string,
 *   imagePath: string | null,
 *   price: string,
 *   altText: string
 * }
 */

import curdRiceTopView from './curdricetopview.jpeg';

const menuItems = [
  {
    id: 1,
    name: "Curd Rice Special",
    description: "Our signature curd rice topped with pomegranate and fresh herbs",
    imagePath: curdRiceTopView,
    price: "$5",
    altText: "Top view of curd rice garnished with pomegranate seeds"
  },
  {
    id: 2,
    name: "Idly",
    description: "Soft, fluffy steamed rice cakes served with sambar and chutney",
    imagePath: "https://images.unsplash.com/photo-1630383249896-424e482df921?w=800&q=80",
    price: "$5",
    altText: "Plate of soft idly with sambar and coconut chutney"
  },
  {
    id: 3,
    name: "Masala Dosa",
    description: "Crispy rice crepe filled with spiced potato masala",
    imagePath: "https://images.unsplash.com/photo-1668236543090-82eba5ee5976?w=800&q=80",
    price: "$5",
    altText: "Golden crispy masala dosa with potato filling"
  },
  {
    id: 4,
    name: "Sambar Rice",
    description: "Aromatic rice mixed with flavorful lentil and vegetable stew",
    imagePath: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?w=800&q=80",
    price: "$5",
    altText: "Bowl of sambar rice with vegetables"
  },
  {
    id: 5,
    name: "Vada",
    description: "Crispy lentil fritters served with coconut chutney",
    imagePath: "https://images.unsplash.com/photo-1601050690117-94f5f6fa8bd7?w=800&q=80",
    price: "$5",
    altText: "Plate of golden medu vada"
  }
];

export default menuItems;
